import React, { useState, useEffect } from "react";
import classes from "./ManageUser.module.css";
import HeaderNav from "../../Components/Dahboard Header/HeaderNav/HeaderNav";
import { useLocation, useNavigate } from "react-router-dom";
import searchicon from "../../Assets/searchicon.png";
import Footer from "../../Components/Footer/Footer";
import { Pen, Trash2 } from "lucide-react";
import "react-loading-skeleton/dist/skeleton.css";
import api, { withCompanyId } from "../../Components/API/Api";
import Skeleton from "react-loading-skeleton";
import Swal from "sweetalert2";
import Select from "react-select";

const Managelocation = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isNewModalOpen, setIsNewModalOpen] = useState(false);
  const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false);
  const [NewUser, setNewUser] = useState([]);
  const [storeOptions, setStoreOptions] = useState([]);
  const [selectedLocation, setSelectedLocation] = useState(null); // For edit/delete
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [submitting, setSubmitting] = useState(false);
  const [deleting, setDeleting] = useState(false);

  const pageMap = {
    "/dashboard": "Dashboard",
    "/transactions": "Transactions",
    "/accounts": "Accounting",
    "/reports": "Reports",
    "/banking": "Banking",
    "/settings": "Settings",
  };

  const [formData, setFormData] = useState({
    description: "",
    location_address: "",
    store_id: "",
  });

  const [editFormData, setEditFormData] = useState({
    description: "",
    location_address: "",
    store_id: "",
  });

  const handleChange = (eOrName, value) => {
    if (typeof eOrName === "string") {
      // For Select
      setFormData((prev) => ({ ...prev, [eOrName]: value }));
    } else {
      // For Input
      const { name, value } = eOrName.target;
      setFormData((prev) => ({ ...prev, [name]: value }));
    }
  };

  const handleEditChange = (eOrName, value) => {
    if (typeof eOrName === "string") {
      // For Select
      setEditFormData((prev) => ({ ...prev, [eOrName]: value }));
    } else {
      // For Input
      const { name, value } = eOrName.target;
      setEditFormData((prev) => ({ ...prev, [name]: value }));
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setSubmitting(true);

    try {
      const payload = {
        description: formData.description,
        location_address: formData.location_address,
        store_id: formData.store_id,
      };

      const body = withCompanyId(payload);
      const response = await api.post(`/v1/location/create`, body);

      setFormData({
        description: "",
        location_address: "",
        store_id: "",
      });

      setIsModalOpen(false);
      fetchLocations(); // Refresh the list

      Swal.fire({
        icon: "success",
        title: "Location Added",
        text: response.data.message || "Location added successfully!",
        timer: 2000,
        showConfirmButton: false,
      });
    } catch (error) {
      const errorMessage =
        typeof error.response?.data?.message === "object"
          ? Object.values(error.response.data.message).flat().join("\n")
          : error.response?.data?.message || "Something went wrong.";

      Swal.fire({
        icon: "error",
        title: "Failed to Add Location",
        text: errorMessage,
      });
    } finally {
      setSubmitting(false);
    }
  };

  const handleEditSubmit = async (e) => {
    e.preventDefault();
    setSubmitting(true);

    try {
      const payload = {
        description: editFormData.description,
        location_address: editFormData.location_address,
        store_id: editFormData.store_id,
      };

      const body = withCompanyId(payload);
      // ID as query param
      const response = await api.post(`/v1/location/update`, body, { params: { id: selectedLocation.id } });

      setIsNewModalOpen(false);
      setSelectedLocation(null);
      fetchLocations(); // Refresh the list

      Swal.fire({
        icon: "success",
        title: "Location Updated",
        text: response.data.message || "Location updated successfully!",
        timer: 2000,
        showConfirmButton: false,
      });
    } catch (error) {
      const errorMessage =
        typeof error.response?.data?.message === "object"
          ? Object.values(error.response.data.message).flat().join("\n")
          : error.response?.data?.message || "Failed to update location.";

      Swal.fire({
        icon: "error",
        title: "Failed to Update Location",
        text: errorMessage,
      });
    } finally {
      setSubmitting(false);
    }
  };

  const handleDelete = async () => {
    setDeleting(true);

    try {
      const response = await api.get(`/v1/location/delete`, { params: { id: selectedLocation.id } });

      setIsDeleteModalOpen(false);
      setSelectedLocation(null);
      fetchLocations(); // Refresh the list

      Swal.fire({
        icon: "success",
        title: "Location Deleted",
        text: response.data.message || "Location deleted successfully!",
        timer: 2000,
        showConfirmButton: false,
      });
    } catch (error) {
      const errorMessage =
        error.response?.data?.message || "Failed to delete location.";

      Swal.fire({
        icon: "error",
        title: "Failed to Delete Location",
        text: errorMessage,
      });
    } finally {
      setDeleting(false);
    }
  };


  const openEditModal = (location) => {
    setSelectedLocation(location);
    setEditFormData({
      description: location.description,
      location_address: location.location_address,
      store_id: location.store_id,
    });
    setIsNewModalOpen(true);
  };

  const openDeleteModal = (location) => {
    setSelectedLocation(location);
    setIsDeleteModalOpen(true);
  };

  useEffect(() => {
    const authToken = localStorage.getItem("authToken");

    if (!authToken) {
      setError("Authorization token not found.");
      navigate("/signin");
      return;
    }

    fetchStore();
    fetchLocations();
  }, [navigate]);

  const fetchStore = async () => {
    try {
      const response = await api.get(`/v1/store`);

      if (response.data.status) {
        setStoreOptions(
          response.data.data.map((s) => ({ value: s.id, label: s.store_name }))
        );
      }
    } catch (error) {
      console.error("Failed to fetch stores:", error);
      if (error.response?.status === 401) {
        localStorage.removeItem("authToken");
        navigate("/login");
      }
    }
  };

  const fetchLocations = async () => {
    try {
      const res = await api.get(`/v1/location`);

      setNewUser(res.data?.data || []);
    } catch (err) {
      console.error("Error fetching locations:", err?.response?.data || err.message);
      setError("Failed to fetch locations. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  const getStoreName = (storeId) => {
    const store = storeOptions.find(option => option.value === storeId);
    return store ? store.label : storeId;
  };

  return (
    <div>
      <HeaderNav activePage={pageMap[location.pathname]} />
      <div className={classes.PgeContainerDisp}>
        <div className={classes.actionsbtn_On}>
          <button
            className={classes.btns_New}
            onClick={() => navigate("/transactions/sales-invoice/sale")}
          >
            Sales Invoice
          </button>
          <button
            className={classes.btns_New}
            onClick={() => navigate("/inventory/purchaseOrder")}
          >
            Purchase Invoice
          </button>
          <button
            className={`${classes.btns_New} ${classes.greens}`}
            onClick={() => navigate("/settings/product-services")}
          >
            Product & Services
          </button>
          <button className={`${classes.btns_News} ${classes.greens}`}>
            Manage Outlet
          </button>
        </div>

        <header className={classes.FrtHeaderOne}>
          <h2 className={classes.FrtTitleOne}>Manage Outlet</h2>
        </header>


{/* Cards commented out for now, can be re-enabled if needed in the future. */}
        {/* <div className={classes.entrjjyer}>
          <div className={classes.allkadsPage}>
            <div className={classes.thrdkadPage}>
              <div className={classes.kadOne}>
                <p className={classes.kdptgpt}>Total Outlets</p>
                <p className={classes.kdptgpt1}>0</p>
                <div className={classes.rvnueOpt}>
                  <p className={classes.skaltxt001}>This month</p>
                </div>
              </div>
            </div>
            <div className={classes.frtkadIs}>
              <div className={classes.kadOne}>
                <p className={classes.kdptgpt}>Outstanding</p>
                <p className={classes.kdptgpt2}>₦0.00</p>
                <div className={classes.rvnueOpt}>
                  <p className={classes.skaltxt001}>Pending payments</p>
                </div>
              </div>
            </div>
            <div className={classes.fiftkadOn}>
              <div className={classes.kadOne}>
                <p className={classes.kdptgpt}>Overdue</p>
                <p className={classes.kdptgpt3}>₦0.00</p>
                <div className={classes.rvnueOpt}>
                  <p className={classes.skaltxt001}>Past due dates</p>
                </div>
              </div>
            </div>
            <div className={classes.frstkadOne}>
              <div className={classes.kadOne}>
                <p className={classes.kdptgpt}>This month</p>
                <p className={classes.kdptgpt4}>0</p>
                <div className={classes.rvnueOpt}>
                  <p className={classes.skaltxt001}>Total invoices</p>
                </div>
              </div>
            </div>
          </div>
        </div> */}

        <div className={classes.headerforActions}>
          <div className={classes.actionsSideRight}>
            <div className={classes.inputWrapperTxt}>
              <img
                src={searchicon}
                alt="Search"
                className={classes.inputIconGreenLrg}
              />
              <input
                type="text"
                className={classes.searchLxtBar}
                placeholder="Search Outlet"
              />
            </div>
          </div>
          <button
            className={classes.btnssBtnss}
            onClick={() => setIsModalOpen(true)}
          >
            Add Outlet
          </button>
        </div>

        <div className={classes.newUserCont}>
          <table className={classes.newUserTable}>
            <thead>
              <tr>
                <th>ID</th>
                <th>Description</th>
                <th>Address</th>
                <th>Store</th>
                <th>Created At</th>
                <th className={classes.actionMove}>Action</th>
              </tr>
            </thead>
            <tbody>
              {loading ? (
                Array(5).fill().map((_, idx) => (
                  <tr key={idx}>
                    {Array(6).fill().map((_, i) => (
                      <td key={i}><Skeleton height={20} /></td>
                    ))}
                  </tr>
                ))
              ) : NewUser.length === 0 ? (
                <tr>
                  <td colSpan={6} style={{ textAlign: "center" }}>No Location found.</td>
                </tr>
              ) : (
                NewUser.map((loc, index) => (
                  <tr key={loc.id}>
                    <td>{index + 1}</td>
                    <td>{loc.description}</td>
                    <td>{loc.location_address}</td>
                    <td>{getStoreName(loc.store?.store_name)}</td>
                    <td>{new Date(loc.created_at).toLocaleDateString()}</td>
                    <td className={classes.actionsEditDelete}>
                      <Pen
                        size={16}
                        className={classes.editActionIcon}
                        onClick={() => openEditModal(loc)}
                        style={{ cursor: 'pointer' }}
                      />
                      <Trash2
                        size={16}
                        className={classes.deleteActionIcon}
                        onClick={() => openDeleteModal(loc)}
                        style={{ cursor: 'pointer' }}
                      />
                    </td>
                  </tr>
                ))
              )}
            </tbody>
          </table>

          <div className={classes.paginationContainertxt}>
            <div className={classes.paginationControlstxt}>
              <button>First</button>
              <button className={classes.activation}>1</button>
              <button>Last</button>
              <span className={classes.pageDisplayText}>
                Displaying 1 - {NewUser.length} of {NewUser.length}
              </span>
            </div>
          </div>
        </div>
      </div>

      {/* Add Location Modal */}
      {isModalOpen && (
        <div className={classes.modalModalOverlay}>
          <div className={classes.modalModalContent}>
            <div className={classes.modalModalHeader}>
              <h2>Add Location</h2>
              <button
                className={classes.closeModalBtn}
                onClick={() => setIsModalOpen(false)}
              >
                &times;
              </button>
            </div>

            <form onSubmit={handleSubmit}>
              <div className={classes.modalModalBody}>
                <div className={classes.modalFormRow}>
                  <div className={classes.modalFormGroup}>
                    <label>Description</label>
                    <input
                      type="text"
                      name="description"
                      placeholder="Enter Description"
                      value={formData.description}
                      onChange={handleChange}
                      required
                    />
                  </div>
                  <div className={classes.modalFormGroup}>
                    <label>Store</label>
                    <Select
                      options={storeOptions}
                      isLoading={storeOptions.length === 0}
                      placeholder="Select store"
                      value={
                        storeOptions.find(
                          (opt) => opt.value === formData.store_id
                        ) || null
                      }
                      onChange={(option) =>
                        handleChange("store_id", option.value)
                      }
                    />
                  </div>
                </div>

                <div className={classes.modalFormRow}>
                  <div className={classes.modalFormGroup}>
                    <label>Location address</label>
                    <input
                      type="text"
                      name="location_address"
                      placeholder="Enter Location Address"
                      value={formData.location_address}
                      onChange={handleChange}
                      required
                    />
                  </div>
                </div>
                <div className={classes.modalFormFooter}>
                  <button
                    className={classes.processModalBtn0}
                    disabled={submitting}
                    type="submit"
                  >
                    {submitting ? "Adding..." : "Add Location"}
                  </button>
                </div>
              </div>
            </form>
          </div>
        </div>
      )}

      {/* Edit Location Modal */}
      {isNewModalOpen && (
        <div className={classes.modalModalOverlay}>
          <div className={classes.modalModalContent}>
            <div className={classes.modalModalHeader}>
              <h2>Edit Location</h2>
              <button
                className={classes.closeModalBtn}
                onClick={() => {
                  setIsNewModalOpen(false);
                  setSelectedLocation(null);
                }}
              >
                &times;
              </button>
            </div>

            <form onSubmit={handleEditSubmit}>
              <div className={classes.modalModalBody}>
                <div className={classes.modalFormRow}>
                  <div className={classes.modalFormGroup}>
                    <label>Description</label>
                    <input
                      type="text"
                      name="description"
                      placeholder="Enter Description"
                      value={editFormData.description}
                      onChange={handleEditChange}
                      required
                    />
                  </div>
                  <div className={classes.modalFormGroup}>
                    <label>Store</label>
                    <Select
                      options={storeOptions}
                      isLoading={storeOptions.length === 0}
                      placeholder="Select store"
                      value={
                        storeOptions.find(
                          (opt) => opt.value === editFormData.store_id
                        ) || null
                      }
                      onChange={(option) =>
                        handleEditChange("store_id", option.value)
                      }
                    />
                  </div>
                </div>

                <div className={classes.modalFormRow}>
                  <div className={classes.modalFormGroup}>
                    <label>Location address</label>
                    <input
                      type="text"
                      name="location_address"
                      placeholder="Enter Location Address"
                      value={editFormData.location_address}
                      onChange={handleEditChange}
                      required
                    />
                  </div>
                </div>
                <div className={classes.modalFormFooter}>
                  <button
                    className={classes.processModalBtn0}
                    disabled={submitting}
                    type="submit"
                  >
                    {submitting ? "Updating..." : "Update Location"}
                  </button>
                </div>
              </div>
            </form>
          </div>
        </div>
      )}

      {/* Delete Location Modal */}
      {isDeleteModalOpen && (
        <div className={classes.modalModalOverlay}>
          <div className={classes.modalModalDeleteContent}>
            <div className={classes.modalModalHeader}>
              <h2 style={{ marginBottom: "auto" }}>Delete Location</h2>
              <button
                className={classes.closeModalBtn}
                onClick={() => {
                  setIsDeleteModalOpen(false);
                  setSelectedLocation(null);
                }}
              >
                &times;
              </button>
            </div>

            <div className={classes.modalModalBodyText00}>
              <p>
                Are you sure you want to delete the location "{selectedLocation?.description}"?
                <br />This action cannot be undone.
              </p>
              <div className={classes.modalFormDelFooter}>
                <button
                  className={classes.ModalDeleteBtn0}
                  onClick={handleDelete}
                  disabled={deleting}
                >
                  {deleting ? "Deleting..." : "Delete Location"}
                </button>
              </div>
            </div>
          </div>
        </div>
      )}

      <Footer />
    </div>
  );
};

export default Managelocation;
